import React, { Component } from 'react'

class AddMyPractice extends Component {
    constructor(props) {
        super(props);
        this.state = {
          message: '',
          };
      }
      AddPractice = () =>{         
         let practicescore={
            subject:this.refs.Subject.value,
            PracticeDescription :this.refs.Des.value      
          };
          fetch("https://localhost:44334/api/Practice",{
            method: 'POST',
            headers:{'Content-type':'application/json'},
            body:JSON.stringify(practicescore)
          }).then(r=>r.json()).then(res=>{
             if(res){
                 this.setState({message:"Practice Detail Added"});
             }
          })
      }
    render() {
        return (
            <div>
                 <h2>Please Enter Practice Details...</h2>
                <p>
                <label>subject : <input type="text" ref="Subject"></input></label>
                </p>
                <p>
                <label>Description <input type="text" ref="Des"></input></label>
                </p>
                <button onClick={this.AddPractice} >Create</button>
                <p style={{fontSize:"16px",color:'green'}}>{this.state.message}</p>
            </div>
        )
    }
}
export {AddMyPractice}